export default {
  title: 'Raporty przychodów',
  sections: {
    new_report: 'Nowy raport',
  },
  form: {
    period: {
      label: 'Okres',
    },
  },
  buttons: {
    export: 'Eksportuj',
  },
  toasts: {
    failed_to_create_report: 'Nie udało się utworzyć raportu',
  },
};
